<template>
    <div
            class="step col"
            :class="stepClass"
            @click="handleClick"
    >
        <div v-html="step.text" />
        <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 18.9 41"
                style="enable-background:new 0 0 18.9 41;"
                xml:space="preserve"
        >

            <polygon
                    class="st0"
                    points="3.9,0.5 0,0.5 0,40.5 3.9,40.5 18.9,20.5 "
            />
</svg>
</div>
</template>
<script>

    const ON_HOLD = 10;
    const CURRENT = 20;
    const DONE = 30;
    export {ON_HOLD, CURRENT, DONE};

    export default {
        name: 'Step',
        props: {
            step: {
                type: Object,
                required: true,
            },
        },

        methods: {
            handleClick() {
                this.$emit('stepClicked', this.step.text);
            }
        },

        computed: {
            stepClass() {
                return {
                    'current': this.step.status === CURRENT,
                    'done': this.step.status === DONE,
                };
            },
        },
    };

</script>
<style
        lang="scss"
        scoped
>
    @import '~bootstrap/scss/functions';
    @import "../scss/_variables.scss";

    .step {
        background-color: $gray-100;
        color:            $gray-800;
        padding:          $step-tracker-step-padding;
        font-weight:      $font-weight-bold;
        font-size:        $font-size-sm;
        width:            $step-tracker-step-width;
        text-align:       center;
        position:         relative;

        svg {
            position: absolute;
            top:      $step-tracker-svg-top;
            right:    $step-tracker-svg-right;
            height:   $step-tracker-svg-height;
            z-index:  $step-tracker-svg-z-index;

            polygon {
                fill: $gray-100;
            }
        }

        &.done {
            background-color: $step-tracker-done-color;

            polygon {
                fill: $step-tracker-done-color;
            }
        }

        &.current {
            background-color: $primary;
            color:            $white;

            polygon {
                fill: $primary;
            }
        }
    }

    @media (max-width: $step-tracker-small-screen-media-max-width) {
        .step {
            width:         100% !important;
            max-width:     $step-tracker-small-screen-step-max-width !important;
            margin-bottom: $step-tracker-small-screen-step-margin-bottom;
            padding:       $step-tracker-small-screen-step-padding;

            svg {
                display: none;
                right:   $step-tracker-small-screen-step-svg-right;
            }

            &.current {
                svg {
                    display: block;
                }
            }
        }
    }
</style>
